import { useCallback, useState } from "react";

import Stripe from "stripe";
import { api } from "@cvx/_generated/api";
import { useAction } from "convex/react";

export interface UseStripeConnectAccountReturn {
  account: Stripe.Account | null;
  hasAccount: boolean;
  isLoading: boolean;
  isChecked: boolean;
  checkStripeConnectAccount: () => Promise<{
    hasAccount: boolean;
    account: Stripe.Account | null;
  }>;
}

export function useStripeConnectAccount(): UseStripeConnectAccountReturn {
  const [account, setAccount] = useState<Stripe.Account | null>(null);
  const [hasAccount, setHasAccount] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const checkStripeConnectAccountAction = useAction(
    api.stripe.checkUserStripeConnectAccount,
  );

  const checkStripeConnectAccount = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await checkStripeConnectAccountAction();
      setAccount(result.account);
      setHasAccount(result.hasAccount);
      setIsChecked(true);
      return result;
    } catch (error) {
      console.error("Error checking Stripe Connect account:", error);
      setAccount(null);
      setHasAccount(false);
      setIsChecked(true);
      return { hasAccount: false, account: null };
    } finally {
      setIsLoading(false);
    }
  }, [checkStripeConnectAccountAction]);

  return {
    account,
    hasAccount,
    isLoading,
    isChecked,
    checkStripeConnectAccount,
  };
}
